<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-audit-logs', params: {id: accountId}}">
              {{ $t('accountAuditLogs.accountDetailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ resourceId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('accountAuditLogs.accountDetailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="entry">
              <audit-log-details :details="entry"/>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import AuditLogDetails from 'src/components/AuditLog/AuditLogDetails.vue'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountAuditLog",
  components: {
    AuditLogDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    resourceId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountAuditLog']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountAuditLog({accountID: this.accountId, resourceId: this.resourceId});
  },
  computed: {
    ...mapState({
      // darkTheme: state => state.app.darkMode,
      loading: state => state.account_audit_log.loading,
      entry: state => state.account_audit_log.data,
    }),
  },
}
</script>

